import React, { useState } from "react";
import Slider from "react-slick";

import 'aos/dist/aos.css';
import '../assets/Header.css';
import '../assets/HeroSection.css';

import EnquiryForm from "./EnquiryForm";
import Whatsapp from "./Whatsapp";

// Images
import panshetMahotsav from '../assets/imgs/hero-banner2.webp';
import sakalpuraskar from '../assets/imgs/sakal-gaurav-puraskar.webp';
import ssg2 from '../assets/events/ssg-2.webp';
import newyear from '../assets/imgs/new-year-hero.webp';
import directorsMsg from '../assets/imgs/directors-msg.png';

function HeroSection() {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const slides = [
        {
            image: directorsMsg,
            heading: "",
            subheading: "",
            bullets: [""],
            cta1: "Enquire Now",
        },
        {
            image: newyear,
            heading: "Nothing changes on 1st January..",
            subheading: "Unless you change something real.",
            bullets: [""],
            cta1: "Enquire Now",
        },
        {
            image: ssg2,
            heading: "Sai-Samriddhi Sohala @ Riviera Greens - 21st Dec 2025",
            subheading: "50+ acres Nature Luxury",
            bullets: [""],
            cta1: "Enquire Now",
        },
        {
            image: panshetMahotsav,
            heading: "Panshet Mahotsav - 23 Dec 2025",
            subheading: "100+ families explored Waterscape",
            bullets: ["Closed 50% bookings in a single day!"],
            cta1: "Enquire Now",
        },
        {
            image: sakalpuraskar,
            heading: "Samriddhi Group",
            subheading: "सकाळ गौरव गाथा पुरस्कार for Sustainable Development",
            bullets: ["Awarded on 24 June 2025"],
            cta1: "Enquire Now",
        }
    ];

    const sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        swipe: true,
        touchMove: true,
        pauseOnHover: false,
        adaptiveHeight: true
    };

    const handleCloseModal = () => setIsModalVisible(false);

    return (
        <>
            <div className="hero-container">
                <Slider {...sliderSettings}>
                    {slides.map((slide, index) => (
                        <div key={index} className="hero-slide active">
                            <img
                                src={slide.image}
                                alt={slide.heading}
                                className="hero-image"
                            />

                            <div className="hero-slide-content">
                                <h3 className="hero-heading">{slide.heading}</h3>
                                <p className="hero-subheading">{slide.subheading}</p>

                                <ul className="hero-bullets">
                                    {slide.bullets.map((point, i) => (
                                        <li key={i}>• {point}</li>
                                    ))}
                                </ul>

                                {slide.cta1 && (
                                    <div className="hero-buttons">
                                        <button
                                            className="scheduleVisit"
                                            onClick={() => setIsModalVisible(true)}
                                        >
                                            {slide.cta1}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </Slider>

                {/* MODAL */}
                {isModalVisible && (
                    <div className="h-modal-overlay" onClick={handleCloseModal}>
                        <div
                            className="h-modal-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="h-close-modal"
                                onClick={handleCloseModal}
                            >
                                ×
                            </button>
                            <EnquiryForm />
                        </div>
                    </div>
                )}
            </div>

            <div className="short-intro-sg">
                <p className="short-intro-sg-heading">
                    Samriddhi Group Builders & Developers
                </p>
                <p className="short-intro-sg-para">
                    At Samriddhi Group, we believe land is more than property—it's a lifestyle, an inheritance, and a personal sanctuary.
                    <br />
                    Our projects are born from a simple vision:
                    <br />
                    “Let nature enrich life, and let land enrich generations.”
                    <br />
                    From mango farms in Konkan to wellness retreats near Lonavala and riverside escapes near Pune, every project balances three elements:
                    <br />
                    Peaceful living • Smart investing • Emotional connection
                    <br />
                    Whether you're seeking a weekend retreat, a future retirement haven, or a secure long-term investment—Samriddhi Group builds spaces where life flows naturally.
                </p>
            </div>

            <Whatsapp />
        </>
    );
}

export default HeroSection;
